import React from 'react'
import { node } from 'prop-types'
import styled from 'styled-components'

const Fit = styled.span`
  display: inline-block;
  white-space: nowrap;
  line-height: 1;
`

const Fitty = ({ children }) => {
  return <Fit className="fit">{children}</Fit>
}

Fitty.propTypes = {
  children: node.isRequired
}

export default Fitty
